import { getFragmentData, graphql } from "../gql";
import { useQuery } from "@apollo/client";
import { BulkClassRoomCreationRequestFragment } from "./BulkClassRoomCreationRequestFragment.ts";
import { BulkClassRoomCreationRequestGraphqlDto } from "../gql/graphql.ts";

const GetBulkClassRoomCreationRequestQuery = graphql(`
  query getBulkClassRoomCreationRequest($id: String!) {
    getBulkClassRoomCreationRequest(id: $id) {
      ...BulkClassRoomCreationRequest
    }
  }
`);

export function useGetBulkClassRoomCreationRequest(id: string) {
  const { data, loading, error } = useQuery(
    GetBulkClassRoomCreationRequestQuery,
    {
      variables: { id },
      skip: !id,
      fetchPolicy: "cache-and-network",
      pollInterval: 15000, // Poll ogni 15 secondi
    },
  );

  return {
    request: getFragmentData(
      BulkClassRoomCreationRequestFragment,
      data?.getBulkClassRoomCreationRequest,
    ) as BulkClassRoomCreationRequestGraphqlDto | null | undefined,
    loading,
    error,
  };
}
